export default __webpack_public_path__ + "static/media/part3_img.e318d19e.png";